const DEFAULT_MAX_WIDTH = 900
const CLOUDINARY_UPLOAD_SEGMENT = '/image/upload/'

export function getOptimizedAssetUrl(originalUrl: string, maxWidth = DEFAULT_MAX_WIDTH): string {
  if (originalUrl.includes(CLOUDINARY_UPLOAD_SEGMENT)) {
    const transformations = `c_limit,w_${maxWidth},q_auto,f_webp`
    return originalUrl.replace(CLOUDINARY_UPLOAD_SEGMENT, `${CLOUDINARY_UPLOAD_SEGMENT}${transformations}/`)
  }

  // Contentful-hosted images support query param transformations
  try {
    const url = new URL(originalUrl)
    url.searchParams.set('w', String(maxWidth))
    url.searchParams.set('fm', 'webp')
    url.searchParams.set('q', '80')
    return url.toString()
  } catch {
    return originalUrl
  }
}
